import React, { useState, useEffect, useMemo } from "react";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TablaAlertas from "./MTable_Alerta";
import AADService from "../funcionesAuth.js";

const TIPOS_CALIDAD = [
  "Riesgo con valoraciones con P99 en cero",
  "Riesgo con valoraciones con P50 critico",
  "Riesgo con exposicion en el top 1% de la compañia",
];

const esCalidad = (tipo_alerta = "") => {
  const t = String(tipo_alerta).toLowerCase();
  return TIPOS_CALIDAD.some((kw) => t.includes(String(kw).toLowerCase()));
};

const extractAfterPrefix = (text, prefix) => {
  if (!text) return null;
  // ^prefix\s*\. captura el prefijo seguido de un punto con espacios opcionales
  const re = new RegExp(`^${prefix}\\s*\\.\\s*(.*)$`, "i");
  const match = text.match(re);
  return match ? match[1].trim() : null;
};

const buildDictionaries = (rows) => {
  const dicExplicacion = {}; // { [parametro]: textoDespuésDeExplicacion }
  const dicAyuda = {}; // { [parametro]: textoDespuésDeAyuda }

  for (const row of rows ?? []) {
    const { parametro, vlrmetrica } = row ?? {};
    if (!parametro || !vlrmetrica) continue;

    // ¿Empieza con "Explicacion."?
    if (/^explicacion\s*\./i.test(vlrmetrica)) {
      const texto = extractAfterPrefix(vlrmetrica, "Explicacion");
      if (texto) dicExplicacion[parametro] = texto;
    }

    // ¿Empieza con "Ayuda."?
    if (/^ayuda\s*\./i.test(vlrmetrica)) {
      const texto = extractAfterPrefix(vlrmetrica, "Ayuda");
      if (texto) dicAyuda[parametro] = texto;
    }
  }

  return { dicExplicacion, dicAyuda };
};

const MainAlertas = (props) => {
  const AzureADService = new AADService();
  const token = AzureADService.getToken();
  const [valueWindow, setValueWindow] = useState(0);
  const [bandeja, setFetchBandeja] = useState([]);
  const [dicExplicacion, setDicExplicacion] = useState([]);
  const [dicAyuda, setDicAyuda] = useState([]);
  const handleChange = (event, newValue) => {
    setValueWindow(newValue);
  };
  useEffect(() => {
    const fetchBandeja = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
          "evaluacion/nuevaevaluacion/bandeja/" +
          localStorage.getItem("idusuario") +
          "/" +
          localStorage.getItem("idcompania") +
          "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      if (result.status >= 200 && result.status <= 300) {
        let param = await result.json();

        const propiasConOrigen = (param?.propias ?? []).map((r) => ({
          ...r,
          __origen: "propias",
        }));
        const companiaConOrigen = (param?.compania ?? []).map((r) => ({
          ...r,
          __origen: "compania",
        }));
        setFetchBandeja([...propiasConOrigen, ...companiaConOrigen]);
      } else if (result.status >= 400 && result.status <= 500) {
        setFetchBandeja([]);
        return result.status;
      }
    };
    const fetchComentarios = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
          "general/parametrosGeneralesxGrupo/Alertas/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      if (result.status >= 200 && result.status <= 300) {
        let param = await result.json();
        const { dicExplicacion, dicAyuda } = buildDictionaries(param);

        // Asignamos con los setters
        setDicExplicacion(dicExplicacion ?? {});
        setDicAyuda(dicAyuda ?? {});
      } else if (result.status >= 400 && result.status <= 500) {
        return result.status;
      }
    };
    fetchBandeja();
    fetchComentarios();
  }, []);

  const grupos = useMemo(() => {
    const base = bandeja ?? [];
    const vacioClase = () => ({
      propias_encendidas: [],
      propias_apagadas: [],
      compania_encendidas: [],
      compania_apagadas: [],
    });

    const res = {
      gestion: vacioClase(),
      calidad: vacioClase(),
    };

    for (const r of base) {
      const clase = esCalidad(r?.tipo_alerta) ? "calidad" : "gestion";
      const estadoKey = Number(r?.estado) === 1 ? "encendidas" : "apagadas";
      const origenKey = r?.__origen === "propias" ? "propias" : "compania";

      const slot = `${origenKey}_${estadoKey}`;
      res[clase][slot].push(r);
    }

    return res;
  }, [bandeja]);
  const encendidasGestion = [
    ...grupos.gestion.propias_encendidas,
    ...grupos.gestion.compania_encendidas,
  ];
  const apagadasGestion = [
    ...grupos.gestion.propias_apagadas,
    ...grupos.gestion.compania_apagadas,
  ];
  const encendidasCalidad = [
    ...grupos.calidad.propias_encendidas,
    ...grupos.calidad.compania_encendidas,
  ];
  const apagadasCalidad = [
    ...grupos.calidad.propias_apagadas,
    ...grupos.calidad.compania_apagadas,
  ];
  return (
    <div>
      <AppBar
        position="static"
        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
      >
        <Tabs value={valueWindow} onChange={handleChange}>
          <Tab
            label="Gestion"
            style={{ color: "#ffffff", padding: "3px 7px 3px" }}
          />
          <Tab
            label="Calidad"
            style={{ color: "#ffffff", padding: "3px 7px 3px" }}
          />
        </Tabs>
      </AppBar>
      {valueWindow === 0 && encendidasGestion.length > 0 && (
        <>
          <h1>Alertas de Gestión</h1>
          <TablaAlertas
            bandeja={encendidasGestion}
            apagadas={apagadasGestion}
            explicacion={dicExplicacion}
            ayuda={dicAyuda}
          />
        </>
      )}
      {valueWindow === 1 && encendidasCalidad.length && (
        <>
          <h1>Alertas de Calidad</h1>
          <TablaAlertas
            bandeja={encendidasCalidad}
            apagadas={apagadasCalidad}
            explicacion={dicExplicacion}
            ayuda={dicAyuda}
          />
        </>
      )}
    </div>
  );
};

export default MainAlertas;
